module.exports = __webpack_public_path__ + "img/lcl-side-profile.6aa72a42.svg";